'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VideoSource(_ref) {
  var media = _ref.media;

  return _react2.default.createElement('source', { src: media.getValue(), type: media.getAttr('type') });
}

VideoSource.propTypes = {
  media: _react2.default.PropTypes.object.isRequired
};

exports.default = VideoSource;
//# sourceMappingURL=source.js.map


// WEBPACK FOOTER //
// ./src/linear/source.js